/** 创作中心 in-app 路由前缀 */
export const STUDIO_BASE = '/studio'

/** 将 API 返回的 studio_path 规范为 mycanvas 内路由 */
export function resolveStudioPath(path?: string | null): string {
  const raw = path?.trim()
  if (!raw) return STUDIO_BASE
  if (raw.startsWith(`${STUDIO_BASE}/`) || raw === STUDIO_BASE) return raw
  if (raw.startsWith('/productions/')) return `${STUDIO_BASE}${raw}`
  if (raw.startsWith('/production/')) {
    return `${STUDIO_BASE}/productions${raw.slice('/production'.length)}`
  }
  if (raw.startsWith('/writer/')) return `${STUDIO_BASE}${raw}`
  if (raw.startsWith('/creative/')) return `${STUDIO_BASE}${raw}`
  if (raw.startsWith('/invites/')) return `${STUDIO_BASE}${raw}`
  if (raw.startsWith('/')) return `${STUDIO_BASE}${raw}`
  return `${STUDIO_BASE}/${raw}`
}
